import { Steps } from 'antd';
import React, { useEffect, useState } from 'react';
import { progressSteps } from './constant';
const ProgressSteps = ({ props }) => {
    const { scrollToElement, currentStep } = props
    const [current, setCurrent] = useState(0)

    useEffect(() => {
        if (currentStep !== null && currentStep !== undefined) {
            setCurrent(currentStep)
        }
    }, [currentStep])

    const onChange = (value) => {
        setCurrent(value)
        scrollToElement(value)
    }

    return (
        <>
            <Steps
                onChange={onChange}
                progressDot
                current={current}
                direction="vertical"
                items={progressSteps}
            />
        </>
    )
};
export default ProgressSteps;